import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';
import {Form} from '@evag/ec-react';
import '@evag/ec-react/dist/main.css';

import Peticao from 'src/components/forms/parts/Peticao';
import Feedback from 'src/components/forms/parts/Feedback';
import Hero from 'src/components/campaigns/Hero';
import FixedRight from 'src/components/FixedRight';
import Layout from 'src/components/Layout';
import SEO from 'src/components/SEO';
import TextContent from 'src/components/TextContent';
import Page from 'src/models/Page';
import styles from './page-peticao.module.scss';

export default function render({data}) {
  const page = Page.fromWP(data.wordpressPage);
  return (
    <Layout marginRight={true} solidHeader={true}>
      <SEO
        title={page.title}
        description={page.excerpt}
        ogimage={page.ogimage}
      />

      <Hero page={page} />

      <FixedRight bg="red">
        <h2 className={styles.formTitle}>{page.acf.formTitle}</h2>
        <Form
          forms={[
            {
              ...Peticao,
              channelId: page.acf.channelId,
            },
            {
              ...Feedback,
              title: page.title,
              url: page.getURL(),
              text:
                'Muito obrigada! Agora ajude a espalhar essa campanha compartilhando nas redes sociais.',
            },
          ]}
        />
      </FixedRight>

      <TextContent>
        <div dangerouslySetInnerHTML={{__html: page.html}} />
      </TextContent>
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query($id: String!) {
    wordpressPage(id: {eq: $id}) {
      ...WPPage
    }
  }
`;
